import React, { useState } from 'react';
import modalStyles from './Modal.module.css';
const Modal = (props) => {
  if (!props.show) {
    return null;
  }

  return (
    <div className={modalStyles.modal}>
      <div
        className={modalStyles.modal_content}
        onClick={(e) => e.stopPropagation()}
      >
        {props.children}
      </div>
    </div>
  );
};
export default Modal;
